import { useEffect } from 'react'

export const ClearEnclosureFaultsResult = ({ setShowCommandModal }) => {
  useEffect(() => setShowCommandModal(false), [setShowCommandModal])
  return null
}
